import { render, staticRenderFns } from "./appSkin.vue?vue&type=template&id=2d428372&scoped=true"
import script from "./appSkin.vue?vue&type=script&lang=js"
export * from "./appSkin.vue?vue&type=script&lang=js"
import style0 from "./appSkin.vue?vue&type=style&index=0&id=2d428372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d428372",
  null
  
)

export default component.exports